// Thin decorative bars — sit above the footer border
const thinBarBase = {
    position: 'absolute',
    borderRadius: '999px',
    mixBlendMode: 'screen',
    height: 14,
};

export const thinBars = {
    wrapper: {
        position: 'absolute',
        top: -24,
        left: 0,
        right: 0,
        height: 44,
        overflow: 'hidden',
        opacity: 0.7,
        pointerEvents: 'none',
    },
    bar1: { ...thinBarBase, left: '-2.5%',  top: 8,  width: '28vw', background: 'linear-gradient(90deg, #FFDF10, #FF9E00)' },
    bar2: { ...thinBarBase, left: '33%',    top: 20, width: '35vw', background: 'linear-gradient(90deg, #00D7FF, #0078FF)' },
    bar3: { ...thinBarBase, right: 0,       top: 8,  width: '30vw', background: 'linear-gradient(90deg, #0078FF, #000082)' },
};

export const footer = {
    position: 'relative',
    mt: 8,
    borderTop: '1px solid rgba(255,255,255,0.05)',
};

export const grid = {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: 'repeat(4, 1fr)' },
    gap: 4,
    py: { xs: 5, md: 7 },
};

export const brandCol = {
    gridColumn: { md: 'span 2' },
};

export const brandLogo = {
    height: 40,
    width: 'auto',
};

export const brandTagline = {
    mt: 2,
    color: 'var(--ecal-lightgrey)',
    maxWidth: 380,
    fontSize: '0.875rem',
    lineHeight: 1.6,
};

export const colTitle = {
    fontSize: '0.72rem',
    textTransform: 'uppercase',
    letterSpacing: '0.18em',
    color: 'var(--ecal-lightblue)',
    mb: 1.5,
    fontWeight: 600,
};

export const linkList = {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    listStyle: 'none',
    m: 0,
    p: 0,
};

export const link = {
    fontSize: '0.875rem',
    color: 'var(--ecal-lightgrey)',
    textDecoration: 'none',
    '&:hover': { color: 'var(--ecal-white)' },
    transition: 'color 0.15s ease',
};

export const copyrightBar = {
    borderTop: '1px solid rgba(255,255,255,0.05)',
    py: 2.5,
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { md: 'center' },
    justifyContent: { md: 'space-between' },
    gap: 1,
};

export const copyrightText = {
    fontSize: '0.72rem',
    color: 'var(--ecal-midgrey)',
};
